import React from 'react';

export default function ContactAddress3() {
  return (
    <>
      <p><i className="fas fa-home mr-3"></i>Famphy Clinic, 1 Floor, Om City Complex, Budigere, <br/>Bengaluru- 560049, Karnatka </p>
      <p><i className="fas fa-envelope mr-3"></i> hello@famphy.com</p>
      <p><i className="fas fa-phone mr-3"></i> +91 91486 13614</p>      
    </>
  );
}
